import { render, staticRenderFns } from "./descriptionOfPackBatch.vue?vue&type=template&id=a37f661a&"
import script from "./descriptionOfPackBatch.vue?vue&type=script&lang=js&"
export * from "./descriptionOfPackBatch.vue?vue&type=script&lang=js&"
import style0 from "./descriptionOfPackBatch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports